//IMMIGRATION AND CITIZENSHIP

import strs from './../strings';
import { Spacer, DragNDrop, handleUpload, EmptyElement, BackButton, BasicInfoForm, AddressForm, SubmissionArea, DropResult, PDFViewer, Spacer25, ConfirmNewCase, Spacer100, Children, LegalStatus, AuxCompletionProof, Licenses, HaveCompany, ExColony, NumJobs, SignaturePad, NoCasesAvailable } from '../Utils';
import { useAutoAnimate } from '@formkit/auto-animate/react';
import { FormContext } from '../context';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { DocumentsGridPopup, FullscreenDocument } from '../Popups';
import { firestoreTest, getFirestoreDoc, getGlobalDocs, getUser, saveSignature, setCase, setFirebaseDoc, setGlobalDocs, storeMetadata } from '../firestore';
import { availableCases, caseTypeExists, findExistingDocs, genExistingDocURLs, getNumOtherDocs, newCase } from '../utilFunctions';
import { Button, Checkbox, FormControlLabel } from '@mui/material';
import { textAlign } from '@mui/system';
import { ArraigoSocial } from './arraigo_social';
import { ArraigoSociolaboral } from './arraigo_sociolaboral';
import { ArraigoSegundaOportunidad } from './arraigo_segunda_oportunidad';
import { ArraigoSocioformativo } from './arraigo_socioformativo';
import { ArraigoFamiliar } from './arraigo_familiar';

const lang = strs.en;

function LoadingDocs() {
	return(
	<div className='animated-div'>
		<Spacer100 />
		<h3 className='secondary-title centered-text '><i>{lang.loadingDocs}</i></h3>
		<Spacer />
		<div className='center-flex logo-loading-rotate'>
			<img className='header__logo' alt="logo" src='/spinningLogo.png' />
		</div>
	</div>
	);
}



export function UnsubmittedCase({resumeCase = true, caseType, curCase}) {
	const caseTypes = {
		auxToResidence: <AuxToResidence resumeCase={resumeCase} curCase={curCase}/>,
		studentStay: <StudentStay resumeCase={resumeCase} curCase={curCase}/>,
		studentStayRenewal: <StudentStayRenewal resumeCase={resumeCase} curCase={curCase}/>,
		arraigoSocial: <ArraigoSocial resumeCase={resumeCase} curCase={curCase}/>,
		arraigoSociolaboral: <ArraigoSociolaboral resumeCase={resumeCase} curCase={curCase}/>,
		arraigoSegundaOportunidad: <ArraigoSegundaOportunidad resumeCase={resumeCase} curCase={curCase}/>,
		arraigoSocioformativo: <ArraigoSocioformativo resumeCase={resumeCase} curCase={curCase}/>,
		arraigoFamiliar: <ArraigoFamiliar resumeCase={resumeCase} curCase={curCase}/>,
		nonLucrativeResidencyRenewal: <NonLucrativeResidencyRenewal resumeCase={resumeCase} curCase={curCase} />,
		spanishCitizenship: <SpanishCitizenship resumeCase={resumeCase} curCase={curCase} />,
	};
// return the component based on the caseType
	return caseTypes[caseType];
}


export function useInitCase(props) {
	const caseType = props.caseType;

//These two MUST go together!
	const resumeCase = props.resumeCase;
	const [casesAvailable, setCasesAvailable] = useState(true);
	const [confirmNewCase, setConfirmNewCase] = useState(true);
// 	console.log('props.curCase', props.curCase);
	const [globalForm, setGlobalForm] = useState(props.curCase ? props.curCase : {})
	const [globalDocs, setGlobalDocs] = useState(null);
	const hasGlobalFormUpdated = useRef(false);
	const [iframeDoc, setIframeDoc] = useState('');
	const [isIframe, setIsIframe] = useState('hidden');
	const [briefcasePopup, setBriefcasePopup] = useState('hidden');
	const [docPrepop, setDocPrepop] = useState([]);
	const [docPrepopURLs, setDocPrepopURLs] = useState({});
	const [isLoading, setIsLoading] = useState(true);
	const [smallChildren, setSmallChildren] = useState(globalForm.basicInfo?.smallChildren?.value);
	const [numChildren, setNumChildren] = useState(1);
	const [numOtherDocs, setNumOtherDocs] = useState(1);
	const [passportStamp, setPassportStamp] = useState(globalForm.passportStamp?.value);
	const [auxCompletion, setAuxCompletion] = useState(globalForm.auxCompletion?.value);
	const [licenses, setLicenses] = useState(globalForm.licenses?.value);
	const [company, setCompany] = useState(globalForm.company?.value);
	const [exColony, setExColony] = useState(globalForm.exColony?.value);
	const [numJobs, setNumJobs] = useState(globalForm.numJobs?.value);
	const [thirdPartyNational, setThirdPartyNational] = useState(globalForm.thirdPartyNational?.value);
	const [alreadyStudying, setAlreadyStudying] = useState(globalForm.alreadyStudying?.value);
	const [guardian, setGuardian] = useState(globalForm.guardian?.value);
	const [caretaker, setCaretaker] = useState(globalForm.caretaker?.value);
	const [typeOfLicenses, setTypeOfLicenses] = useState(globalForm.typeOfLicenses?.value);
	const [isEmployerFirm, setIsEmployerFirm] = useState(globalForm.isEmployerFirm?.value);
	const [signatureImg, setSignatureImg] = useState(null);
	const [activeDragNDrop, setActiveDragNDrop] = useState(null);
	const resolverRef = useRef(null);

	const value = {globalForm, setGlobalForm, globalDocs, setGlobalDocs, activeDragNDrop, setActiveDragNDrop, resolverRef}

	console.log('LICENSES', licenses)

	async function saveCurCase(saveForm=null) {
		console.log(`saveCurCase`, globalForm, 'saveForm', saveForm)
		let tmpForm = {};
		saveForm = saveForm || globalForm

		const dateOfBirth = saveForm.basicInfo.dateOfBirth ? saveForm.basicInfo.dateOfBirth.format('YYYY-MM-DD') : '';

			tmpForm = {
				...saveForm,
				basicInfo: {
					...saveForm.basicInfo,
					dateOfBirth: dateOfBirth,
				},
			};
			if (saveForm.schoolInfo) {
				const courseStartDate = saveForm.schoolInfo.courseStartDate ? saveForm.schoolInfo.courseStartDate.format('YYYY-MM-DD') : '';
				const courseEndDate = saveForm.schoolInfo.courseEndDate ? saveForm.schoolInfo.courseEndDate.format('YYYY-MM-DD') : '';

				tmpForm = {
					...tmpForm,	
					schoolInfo: {
						...saveForm.schoolInfo,
						courseStartDate: courseStartDate,
						courseEndDate: courseEndDate,
					},
				}
			}

		await setCase(tmpForm.id, tmpForm);
		console.log('saveCurCase End', tmpForm)
	}

	function incrementChildren() {
		const newNumChildren = globalForm.numChildren + 1;
		setNumChildren(numChildren + 1)
		setGlobalForm({
			...globalForm,
			numChildren: newNumChildren,
		});
	}

	function decrementChildren() {
		if (numChildren <= 1) return;

		const newNumChildren = globalForm.numChildren - 1;
		setNumChildren(numChildren - 1);
		setGlobalForm({
			...globalForm,
			numChildren: newNumChildren
		})
	}

	function handleTextAreaChangeOtherDocs(event, index) {
		setGlobalForm((prev) => ({
			...prev,
			docs: prev.docs.map((doc, i) =>
				doc.docType === `other${index + 1}` ? { ...doc, msg: event.target.value } : doc
			),
		}));
	}

//Figure out of we are resuming a case and, if not, if we need to confirm a new case with a dialog
	useEffect(
		() => {
			const wrapperAsync = async () => {
				if (resumeCase) {
					setConfirmNewCase(false);
					setIsLoading(false);
				}
				else {
					const user = await getUser();
					const availCases = user?.availCases;
					console.log('availCases', availCases);
					if (availCases === 0 ) {
						setCasesAvailable(false);
						return;
					}
					const existsSimilarCase = await caseTypeExists(caseType); 
					console.log('existsSimilarCase', existsSimilarCase);
					setConfirmNewCase(existsSimilarCase);
// 					setIsLoading(false);
				}
			}
			wrapperAsync();
		}	
		, []
	)	


//If we aren't confirming a new case, find existing docs
	useEffect(
		() => {
			const wrapperAsync = async () => {
				if (confirmNewCase) return;
				if (resumeCase) {
					const existingDocs = globalForm.docs
					setDocPrepop(existingDocs)
				}
				else {
					console.log('confirmNewCase', confirmNewCase);
					console.log('caseType', caseType)
					const existingDocs = await findExistingDocs(caseType);
					console.log('existingDocs', existingDocs);
					setDocPrepop(existingDocs);
				}
					const tmpGlobalDocs = await getGlobalDocs();
					setGlobalDocs(tmpGlobalDocs?.length);
			}
			wrapperAsync();
		}	
		, [caseType, confirmNewCase]
	
	)	


	useEffect (
		() => {
			const wrapperAsync = async () => {
				if (confirmNewCase) return;
				if (resumeCase) return;
				const tmpNewCase = await newCase(caseType);
				setGlobalForm(tmpNewCase);
				console.log('FINAL DOC PREPOP', docPrepopURLs);
				setIsLoading(false);	
			}
			wrapperAsync();
		},
		[confirmNewCase]
	)


	//This can be run only AFTER the list docPrepop is populated
	useEffect(
		() => {
			const wrapperAsync = async () => {
				console.log('globalForm updated', globalForm)
// 				debugger
				//All this shit to make sure this runs once and only once
				if (!globalForm.docs) return;
				if (confirmNewCase || hasGlobalFormUpdated.current) return;
				hasGlobalFormUpdated.current = true;

				//actualy logic
				if (confirmNewCase) return;
					console.log('new case useEffect', globalForm);
					const tmpDocURLs = await genExistingDocURLs(globalForm, setGlobalForm);
					console.log('tmpDocURLs', tmpDocURLs)
					setDocPrepopURLs(tmpDocURLs);
					setNumOtherDocs(getNumOtherDocs(globalForm.docs));

				setNumChildren(globalForm.numChildren)
			}
			wrapperAsync();
		}	
		, [globalForm, confirmNewCase]
	)

	return {globalForm, setGlobalForm, saveCurCase, iframeDoc, setIframeDoc, isIframe, setIsIframe, docPrepop, setDocPrepop, docPrepopURLs, setDocPrepopURLs, isLoading, setIsLoading, confirmNewCase, setConfirmNewCase, value, smallChildren, setSmallChildren, numChildren, setNumChildren, passportStamp, setPassportStamp, incrementChildren, decrementChildren, auxCompletion, setAuxCompletion, licenses, setLicenses, company, setCompany, exColony, setExColony, numJobs, setNumJobs, thirdPartyNational, setThirdPartyNational, alreadyStudying, setAlreadyStudying, guardian, setGuardian, caretaker, setCaretaker, isEmployerFirm, setIsEmployerFirm, typeOfLicenses, setTypeOfLicenses, signatureImg, setSignatureImg, casesAvailable, setCasesAvailable, numOtherDocs, setNumOtherDocs, handleTextAreaChangeOtherDocs, briefcasePopup, setBriefcasePopup, activeDragNDrop, setActiveDragNDrop, globalDocs, setGlobalDocs}

}

export function AuxToResidence(props) {
	const newProps = {
		...props,
		caseType: "auxToResidence"
	}

	const {globalForm, setGlobalForm, iframeDoc, setIframeDoc, isIframe, setIsIframe, docPrepop, docPrepopURLs, setDocPrepopURLs, isLoading, setIsLoading, confirmNewCase, setConfirmNewCase, value, smallChildren, setSmallChildren, numChildren, setNumChildren, passportStamp, setPassportStamp, saveCurCase, incrementChildren, decrementChildren, auxCompletion, setAuxCompletion, licenses, setLicenses, company, setCompany, exColony, setExColony, numJobs, setNumJobs, typeOfLicenses, setTypeOfLicenses, signatureImg, setSignatureImg, casesAvailable, setCasesAvailable, numOtherDocs, setNumOtherDocs, handleTextAreaChangeOtherDocs, briefcasePopup, setBriefcasePopup, activeDragNDrop, setActiveDragNDrop, globalDocs, setGlobalDocs} = useInitCase(newProps);
	const [signature, setSignature] = useState(null);

// 	function handleSave(signatureDataUrl) {
	function handleSave(globalForm) {
// 		setSignature(signatureDataUrl);
// 		saveSignature(signatureDataUrl);
		saveCurCase(globalForm);

	};


	function handleClick(url) {
		setIframeDoc(url);
		setIsIframe('pdf-viewer-fullscreen fade-in')
	}



	console.log('AUX TO RES LICENSES', licenses)

	function handleTextAreaChangeLicenses(event) {
		setGlobalForm({
			...globalForm,
			typeOfLicenses: event.target.value,
		})		
	}
	
	if (casesAvailable === false) {
		console.log('availableCases === false');
		return <NoCasesAvailable />
	}

	return  confirmNewCase ? <ConfirmNewCase setConfirmNewCase={setConfirmNewCase} />
		:

	(
	isLoading ? <LoadingDocs /> :

	<div>
	<FormContext.Provider value={value}>
		<BackButton />
		<Spacer />
		<div className='form-div'>
			<h3 className='primary-title'>{lang.auxToResidence}  {/* globalForm.id */}</h3>
			
			<Spacer />
				<h3 className='tertiary-title'>{lang.fullPassport}</h3>
				<Spacer25 />
				<div className=''>
				<div className='large-margin'>
				<DragNDrop 
					text=<div>{lang.fullPassport}  {<span style={{color: 'red'}}>*</span>}</div>
					doc='fullPassport' 
					clickCallback={handleClick}
					setBriefcasePopup={setBriefcasePopup}
					customStyle='pdf-viewer-small'
					fileNanoID={docPrepopURLs['fullPassport'] ? docPrepopURLs['fullPassport'].uuid : false}
					initialFileURL={docPrepopURLs['fullPassport'] ? docPrepopURLs['fullPassport'].url : false}
					saveFunc={saveCurCase}
				/>
				</div>
				</div>


			<Spacer />

			<h3 className='tertiary-title'>{lang.proofLegalStatus}</h3>
			<LegalStatus passportStamp={passportStamp} setPassportStamp={setPassportStamp} />	

			{
				<div className={`${passportStamp === false ? 'animated-div' : 'hidden'}`}>
					<Spacer />
					<p className='p larger-font centered-text'>{lang.oneOf}</p>
				<div className={`two-column-upload-grid`}>
					<DragNDrop 
						text={lang.declarationOfEntry} 
						doc='declarationOfEntry'
						setBriefcasePopup={setBriefcasePopup}
						fileNanoID={docPrepopURLs['declarationOfEntry'] ? docPrepopURLs['declarationOfEntry'].uuid : false}
						initialFileURL={docPrepopURLs['declarationOfEntry'] ? docPrepopURLs['declarationOfEntry'].url : false}
						saveFunc={saveCurCase}
					/>

					<DragNDrop 
						text={lang.otherEntryDoc} 
						doc='otherEntryDoc'
						setBriefcasePopup={setBriefcasePopup}
						fileNanoID={docPrepopURLs['otherEntryDoc'] ? docPrepopURLs['otherEntryDoc'].uuid : false}
						initialFileURL={docPrepopURLs['otherEntryDoc'] ? docPrepopURLs['otherEntryDoc'].url : false}
						saveFunc={saveCurCase}
					/>
				</div>
				</div>
			}

			<Spacer />
			<h3 className='tertiary-title'>{lang.requiredDocs}</h3>
			<Spacer />	
			{Object.keys(docPrepop).length > 0 && <p className='p centered-text'>{lang.smartUpload}</p> }
			<Spacer25 />
			<div className='upload-grid animated-div'>

				<DragNDrop 
					text={lang.businessPlan} 
					doc='businessPlan'  
					setBriefcasePopup={setBriefcasePopup}
					clickCallback={handleClick}  
					customStyle='pdf-viewer-small' 
					initialFileURL={docPrepopURLs['businessPlan'] ? docPrepopURLs['businessPlan'].url : false}
					fileNanoID={docPrepopURLs['businessPlan'] ? docPrepopURLs['businessPlan'].uuid : false}

					saveFunc={saveCurCase}

				/>
				<DragNDrop 
					text={lang.qualification} 
					doc='qualification' 
					setBriefcasePopup={setBriefcasePopup}
					clickCallback={handleClick} 
					customStyle='pdf-viewer-small' 
					initialFileURL={docPrepopURLs['qualification'] ? docPrepopURLs['qualification'].url : false}
					fileNanoID={docPrepopURLs['qualification'] ? docPrepopURLs['qualification'].uuid : false}

					saveFunc={saveCurCase}

				/>
				<DragNDrop 
					text={lang.proofOfInvestment} 
					doc='proofOfInvestment' 
					setBriefcasePopup={setBriefcasePopup}
					clickCallback={handleClick} 
					customStyle='pdf-viewer-small' 
					initialFileURL={docPrepopURLs['proofOfInvestment'] ? docPrepopURLs['proofOfInvestment'].url : false}
					fileNanoID={docPrepopURLs['proofOfInvestment'] ? docPrepopURLs['proofOfInvestment'].uuid : false}
					saveFunc={saveCurCase}
				/>

			</div>

			<Spacer />
			<h3 className='tertiary-title'>{lang.certOfAuxCompletion}</h3>

			<AuxCompletionProof auxCompletion={auxCompletion} setAuxCompletion={setAuxCompletion} />	
			{
				<div className={`${auxCompletion === false ? 'animated-div' : 'hidden'}`}>
					<Spacer />
				</div>
			}

			{
				<div className={`${auxCompletion === true ? 'animated-div' : 'hidden'}`}>
					<Spacer />
					<p className='p larger-font centered-text'>{lang.oneOf}</p>
					<div className='large-margin'>
					<DragNDrop 
						text={lang.certOfAuxCompletion} 
						doc='certOfAuxCompletion'
						setBriefcasePopup={setBriefcasePopup}
						fileNanoID={docPrepopURLs['certOfAuxCompletion'] ? docPrepopURLs['certOfAuxCompletion'].uuid : false}
						initialFileURL={docPrepopURLs['certOfAuxCompletion'] ? docPrepopURLs['certOfAuxCompletion'].url : false}
						saveFunc={saveCurCase}
					/>
					</div>
				</div>
			}



			<Spacer />
			<h3 className='tertiary-title'>{lang.license}</h3>
			<Licenses licenses={licenses} setLicenses={setLicenses} /> 
			{
				<div className={`${licenses === true ? 'animated-div' : 'hidden'}`}>
					<Spacer />
					<p className='p larger-font centered-text form-long-text'>{lang.typeOfLicense}&nbsp; <span style={{color: 'red'}}>*</span></p>
					<Spacer />
					<textarea 
						className={`form-text-item form-element text-area`} 
						onChange={handleTextAreaChangeLicenses}
						defaultValue={globalForm?.typeOfLicenses ? globalForm.typeOfLicenses : ''}
					/>
	
				</div>
			}


			<Spacer />
			<h3 className='tertiary-title'>{lang.company}</h3>
			< HaveCompany company={company} setCompany={setCompany} /> 
			{
				<div className={`${company === false ? 'animated-div' : 'hidden'}`}>
					<Spacer />
				</div>
			}
			{
				<div className={`${company === true? 'animated-div' : 'hidden'}`}>
					<Spacer />
					<p className='p larger-font centered-text'>{lang.oneOf}</p>
					<div className='large-margin'>
						<DragNDrop 
							text={lang.bizForms}
							doc='company'
							setBriefcasePopup={setBriefcasePopup}
							fileNanoID={docPrepopURLs['company'] ? docPrepopURLs['company'].uuid : false}
						initialFileURL={docPrepopURLs['company'] ? docPrepopURLs['company'].url : false}
						saveFunc={saveCurCase}
						/>
					</div>
				</div>
			}

			<Spacer />
			<h3 className='tertiary-title'>{lang.exColony}</h3>
			<ExColony exColony={exColony} setExColony={setExColony} /> 
			{
				<div className={`${exColony === false ? 'animated-div' : 'hidden'}`}>
					<Spacer />
					<div className='large-margin'>
						<DragNDrop 
							text={lang.notExColonyFee}
							doc='fee790062'
							setBriefcasePopup={setBriefcasePopup}
							fileNanoID={docPrepopURLs['fee790062'] ? docPrepopURLs['fee790062'].uuid : false}
						initialFileURL={docPrepopURLs['fee790062'] ? docPrepopURLs['fee790062'].url : false}
						saveFunc={saveCurCase}
						/>
					</div>

				</div>
			}
			{
				<div className={`${exColony === true? 'animated-div' : 'hidden'}`}>
					<Spacer />
					<p className='p larger-font centered-text'>{lang.oneOf}</p>
					<div className='large-margin'>
						<DragNDrop 
							text={lang.exColony}
							doc='exColony'
							setBriefcasePopup={setBriefcasePopup}
							fileNanoID={docPrepopURLs['exColony'] ? docPrepopURLs['exColony'].uuid : false}
						initialFileURL={docPrepopURLs['exColony'] ? docPrepopURLs['exColony'].url : false}
						saveFunc={saveCurCase}
						/>
					</div>

					<Spacer />
				</div>
			}

			<Spacer />
			<h3 className='tertiary-title'>{lang.numJobs}</h3>
			<Spacer />
			<p className='p larger-font centered-text'>{lang.employment}</p>
			<NumJobs numJobs={numJobs} setNumJobs={setNumJobs} />
			<Spacer />


			<Spacer />
			<h3 className='tertiary-title'>{lang.criminalAndHealth}</h3>
			<Spacer />
			<p className='p larger-font centered-text'>{lang.requiredIfNotPrev}</p>
			<div className='animated-div two-column-upload-grid'>
				<DragNDrop 
					text={lang.backgroundCheck} 
					doc='backgroundCheck'
					setBriefcasePopup={setBriefcasePopup}
					clickCallback={handleClick} 
					customStyle='pdf-viewer-small' 
					initialFileURL={docPrepopURLs['backgroundCheck'] ? docPrepopURLs['backgroundCheck'].url : false}
					fileNanoID={docPrepopURLs['backgroundCheck'] ? docPrepopURLs['backgroundCheck'].uuid : false}
					saveFunc={saveCurCase}

				/>
				<DragNDrop 
					text={lang.proofHealth} 
					doc='proofHealth' 
					setBriefcasePopup={setBriefcasePopup}
					clickCallback={handleClick} 
					customStyle='pdf-viewer-small'  
					initialFileURL={docPrepopURLs['proofHealth'] ? docPrepopURLs['proofHealth'].url : false}
					fileNanoID={docPrepopURLs['proofHealth'] ? docPrepopURLs['proofHealth'].uuid : false}
					saveFunc={saveCurCase}

				/>
			</div>


			<Spacer />
			<Spacer />

			<h3 className='tertiary-title'>{lang.children}</h3>
		{

		}
			<Children 
				smallChildren={smallChildren}
				setSmallChildren={setSmallChildren}
				setNumChildren={setNumChildren}
			/>
		{
			<div className={`${smallChildren ? '' : 'hidden'}`}>
					<Spacer />
					<p className='p larger-font centered-text'>{lang.oneOrBoth}</p>
			{
				Array.from({length: numChildren}).map((_, i) => (
					<div className={`animated-div two-column-upload-grid`}>
						<DragNDrop 
							text={lang.childSchoolEnrollment + ` ${i+1}`} 
							doc={`childSchoolEnrollment${i+1}`}
							setBriefcasePopup={setBriefcasePopup}
							fileNanoID={docPrepopURLs[`childSchoolEnrollment${i+1}`] ? docPrepopURLs[`childSchoolEnrollment${i+1}`].uuid : false}
							initialFileURL={docPrepopURLs[`childSchoolEnrollment${i+1}`] ? docPrepopURLs[`childSchoolEnrollment${i+1}`].url : false}
							saveFunc={saveCurCase}
						/>

						<DragNDrop 
							text={lang.childCourseCompletion + ` ${i+1}`} 
							doc={`childCourseCompletion${i+1}`}
							setBriefcasePopup={setBriefcasePopup}
							fileNanoID={docPrepopURLs[`childCourseCompletion${i+1}`] ? docPrepopURLs[`childCourseCompletion${i+1}`].uuid : false}
							initialFileURL={docPrepopURLs[`childCourseCompletion${i+1}`] ? docPrepopURLs[`childCourseCompletion${i+1}`].url : false}
							saveFunc={saveCurCase}
						/>
					</div>
				))
			}

			<div className='center-flex'>
				<button className='form-action-btn new-btn' onClick={incrementChildren}>Add child +</button>
				<button className='form-action-btn new-btn' onClick={decrementChildren}>Delete child +</button>
			</div>

			</div>
		}


		{
			<>
			<Spacer100 />
			<h3 className='tertiary-title'>{lang.additionalDocs}</h3>
			<Spacer />
			<p className='larger-font centered-text'>{lang.anyAdditionalDocs}</p>
			<Spacer />

			{
			Array.from({ length: numOtherDocs }).map((_, i) => {
				console.log('message', docPrepopURLs[`other${i+1}`]);
				
				return(
				<div className='large-margin animated-div'>
					<DragNDrop text={lang.other} 
						doc={`other${i+1}`}
						setBriefcasePopup={setBriefcasePopup}
						clickCallback={handleClick} 
						customStyle='pdf-viewer-small' 
						initialFileURL={docPrepopURLs[`other${i+1}`] ? docPrepopURLs[`other${i+1}`].url : false}
						fileNanoID={docPrepopURLs[`other${i+1}`] ? docPrepopURLs[`other${i+1}`].uuid : false}
						saveFunc={saveCurCase}
						msg={docPrepopURLs[`other${i+1}`]?.msg}
					/>
					<div className='center-flex'>
					<textarea className='text-area' defaultValue={docPrepopURLs[`other${i+1}`] ? docPrepopURLs[`other${i+1}`].msg : ''} placeholder={lang.optionalMessage} onChange={(e) => handleTextAreaChangeOtherDocs(e, i)}></textarea>
					</div>
					<Spacer />
					<Spacer25 />
				</div>
				);
			})
			}

			<div className='center-flex'>
				<button className='form-action-btn new-btn' onClick={() => {
					setNumOtherDocs(numOtherDocs + 1);
				}}>{lang.addDocument} +</button>
			</div>
			</>
		}

			<Spacer100 />

			<h3 className='tertiary-title'>{lang.basicInfo}</h3>
			<Spacer />
			<p className='p'>{lang.smartAutoFill}</p>
			<Spacer25 />
			<BasicInfoForm />
			<Spacer />
			<h3 className='tertiary-title'>{lang.physicalAddress}</h3>
			<Spacer />
			<AddressForm />
			<Spacer />
			<div className='center-flex'>
		
			<SubmissionArea saveFunc={saveCurCase} signatureImg={signatureImg}/>

			</div>

				<h3 className='tertiary-title'>{lang.signaturePad}</h3>
				<Spacer25 />
				<p className='p centered-text'>{lang.signatureForm}</p>
				<Spacer />
				<div className='center-flex'>
					<SignaturePad saveFunc={saveCurCase} updateSignatureImg={setSignatureImg} />
				</div>

		</div>
	<FullscreenDocument visible={isIframe} closeFunc={setIsIframe} src={iframeDoc} />
	<DocumentsGridPopup onSelect={() => {console.log('onSelect')}} isVisible={briefcasePopup} setIsVisible={setBriefcasePopup}/>

	</FormContext.Provider>
	</div>
	);
}


export function StudentStay(props) {
	const newProps = {
		...props,
		caseType: "studentStay"
	}

	const {globalForm, setGlobalForm, iframeDoc, setIframeDoc, isIframe, setIsIframe, docPrepop, docPrepopURLs, setDocPrepopURLs, isLoading, setIsLoading, confirmNewCase, setConfirmNewCase, value, smallChildren, setSmallChildren, numChildren, setNumChildren, passportStamp, setPassportStamp, saveCurCase, incrementChildren, decrementChildren} = useInitCase(newProps);
	function handleClick(url) {
		setIframeDoc(url);
		setIsIframe('pdf-viewer-fullscreen fade-in')
	}

	console.log('typeOfStreetOptions', lang.typeOfStreetOptions)
	console.log("autovía")


	return  confirmNewCase ? <ConfirmNewCase setConfirmNewCase={setConfirmNewCase} />
		:

	(
	isLoading ? <LoadingDocs /> :

	<div>
	<FormContext.Provider value={value}>
		<BackButton />
		<Spacer />
		<div className='form-div'>
			<h3 className='primary-title'>{lang.studentStay}  {globalForm.id}</h3>
			
			<Spacer />
				<h3 className='tertiary-title'>{lang.fullPassport}</h3>
				<Spacer25 />
				<div className=''>
				<div className='large-margin'>
				<DragNDrop 
					text={lang.fullPassport} 
					doc='fullPassport' 
					clickCallback={handleClick}
					customStyle='pdf-viewer-small'
					fileNanoID={docPrepopURLs['fullPassport'] ? docPrepopURLs['fullPassport'].uuid : false}
					initialFileURL={docPrepopURLs['fullPassport'] ? docPrepopURLs['fullPassport'].url : false}
					saveFunc={saveCurCase}
				/>
				</div>
				</div>


			<Spacer />

			<h3 className='tertiary-title'>{lang.proofLegalStatus}</h3>
			<LegalStatus passportStamp={passportStamp} setPassportStamp={setPassportStamp} />	

			{
				<div className={`${passportStamp === false ? 'animated-div' : 'hidden'}`}>
					<Spacer />
					<p className='p larger-font centered-text'>{lang.oneOf}</p>
				<div className={`two-column-upload-grid`}>
					<DragNDrop 
						text={lang.declarationOfEntry} 
						doc='declarationOfEntry'
						fileNanoID={docPrepopURLs['declarationOfEntry'] ? docPrepopURLs['declarationOfEntry'].uuid : false}
						initialFileURL={docPrepopURLs['declarationOfEntry'] ? docPrepopURLs['declarationOfEntry'].url : false}
						saveFunc={saveCurCase}
					/>

					<DragNDrop 
						text={lang.otherEntryDoc} 
						doc='otherEntryDoc'
						fileNanoID={docPrepopURLs['otherEntryDoc'] ? docPrepopURLs['otherEntryDoc'].uuid : false}
						initialFileURL={docPrepopURLs['otherEntryDoc'] ? docPrepopURLs['otherEntryDoc'].url : false}
						saveFunc={saveCurCase}
					/>
				</div>
				</div>
			}

			<Spacer />
			<h3 className='tertiary-title'>{lang.requiredDocs}</h3>
			<Spacer />	
			{Object.keys(docPrepop).length > 0 && <p className='p centered-text'>{lang.smartUpload}</p> }
			<Spacer25 />
			<div className='upload-grid animated-div'>

				<DragNDrop 
					text={lang.proofAdmission} 
					doc='proofAdmission'  
					clickCallback={handleClick}  
					customStyle='pdf-viewer-small' 
					initialFileURL={docPrepopURLs['proofAdmission'] ? docPrepopURLs['proofAdmission'].url : false}
					fileNanoID={docPrepopURLs['proofAdmission'] ? docPrepopURLs['proofAdmission'].uuid : false}

					saveFunc={saveCurCase}

				/>
				<DragNDrop 
					text={lang.financialMeans} 
					doc='financialMeans' 
					clickCallback={handleClick} 
					customStyle='pdf-viewer-small' 
					initialFileURL={docPrepopURLs['financialMeans'] ? docPrepopURLs['financialMeans'].url : false}
					fileNanoID={docPrepopURLs['financialMeans'] ? docPrepopURLs['financialMeans'].uuid : false}

					saveFunc={saveCurCase}

				/>
				<DragNDrop 
					text={lang.proofInsurance} 
					doc='proofInsurance' 
					clickCallback={handleClick} 
					customStyle='pdf-viewer-small' 
					initialFileURL={docPrepopURLs['proofInsurance'] ? docPrepopURLs['proofInsurance'].url : false}
					fileNanoID={docPrepopURLs['proofInsurance'] ? docPrepopURLs['proofInsurance'].uuid : false}
					saveFunc={saveCurCase}

				/>
			</div>

			<Spacer />
			<h3 className='tertiary-title'>{lang.moreThanSixMonths}</h3>
			<Spacer />
			<div className='animated-div two-column-upload-grid'>

				<DragNDrop 
					text={lang.backgroundCheck} 
					doc='backgroundCheck'
					clickCallback={handleClick} 
					customStyle='pdf-viewer-small' 
					initialFileURL={docPrepopURLs['backgroundCheck'] ? docPrepopURLs['backgroundCheck'].url : false}
					fileNanoID={docPrepopURLs['backgroundCheck'] ? docPrepopURLs['backgroundCheck'].uuid : false}
					saveFunc={saveCurCase}

				/>
				<DragNDrop 
					text={lang.proofHealth} 
					doc='proofHealth' 
					clickCallback={handleClick} 
					customStyle='pdf-viewer-small'  
					initialFileURL={docPrepopURLs['proofHealth'] ? docPrepopURLs['proofHealth'].url : false}
					fileNanoID={docPrepopURLs['proofHealth'] ? docPrepopURLs['proofHealth'].uuid : false}
					saveFunc={saveCurCase}

				/>
			</div>


			<Spacer />
			<h3 className='tertiary-title'>{lang.mayBeRequired}</h3>
			<Spacer />
			<div className='large-margin animated-div'>
				<DragNDrop text={lang.poa} 
					doc='poa' 
					clickCallback={handleClick} 
					customStyle='pdf-viewer-small' 
					initialFileURL={docPrepopURLs['poa'] ? docPrepopURLs['poa'].url : false}
					fileNanoID={docPrepopURLs['poa'] ? docPrepopURLs['poa'].uuid : false}
					saveFunc={saveCurCase}

				/>
			</div>
			<Spacer />

			<h3 className='tertiary-title'>{lang.children}</h3>
		{

		}
			<Children 
				smallChildren={smallChildren}
				setSmallChildren={setSmallChildren}
				setNumChildren={setNumChildren}
			/>
		{
			<div className={`${smallChildren ? '' : 'hidden'}`}>
					<Spacer />
					<p className='p larger-font centered-text'>{lang.oneOrBoth}</p>
			{
				Array.from({length: numChildren}).map((_, i) => (
					<div className={`animated-div two-column-upload-grid`}>
						<DragNDrop 
							text={lang.childSchoolEnrollment + ` ${i+1}`} 
							doc={`childSchoolEnrollment${i+1}`}
							fileNanoID={docPrepopURLs[`childSchoolEnrollment${i+1}`] ? docPrepopURLs[`childSchoolEnrollment${i+1}`].uuid : false}
							initialFileURL={docPrepopURLs[`childSchoolEnrollment${i+1}`] ? docPrepopURLs[`childSchoolEnrollment${i+1}`].url : false}
							saveFunc={saveCurCase}
						/>

						<DragNDrop 
							text={lang.childCourseCompletion + ` ${i+1}`} 
							doc={`childCourseCompletion${i+1}`}
							fileNanoID={docPrepopURLs[`childCourseCompletion${i+1}`] ? docPrepopURLs[`childCourseCompletion${i+1}`].uuid : false}
							initialFileURL={docPrepopURLs[`childCourseCompletion${i+1}`] ? docPrepopURLs[`childCourseCompletion${i+1}`].url : false}
							saveFunc={saveCurCase}
						/>
					</div>
				))
			}

			<div className='center-flex'>
				<button className='form-action-btn new-btn' onClick={incrementChildren}>Add child +</button>
				<button className='form-action-btn new-btn' onClick={decrementChildren}>Delete child +</button>
			</div>

			</div>
		}

			<Spacer100 />

			<h3 className='tertiary-title'>{lang.basicInfo}</h3>
			<Spacer />
			<p className='p'>{lang.smartAutoFill}</p>
			<Spacer25 />
			<BasicInfoForm />
			<Spacer />
			<h3 className='tertiary-title'>{lang.physicalAddress}</h3>
			<Spacer />
			<AddressForm />
			<Spacer />
			<div className='center-flex'>
		
				<SubmissionArea saveFunc={saveCurCase}/>
			</div>
		</div>
	</FormContext.Provider>
	<FullscreenDocument visible={isIframe} closeFunc={setIsIframe} src={iframeDoc} />
	</div>
	);
}

export function StudentStayRenewal(props) {
	const newProps = {
		...props,
		caseType: "studentStayRenewal"
	}

	const {globalForm, setGlobalForm, iframeDoc, setIframeDoc, isIframe, setIsIframe, docPrepop, docPrepopURLs, setDocPrepopURLs, isLoading, setIsLoading, confirmNewCase, setConfirmNewCase, value, smallChildren, setSmallChildren, numChildren, setNumChildren, passportStamp, setPassportStamp, saveCurCase, incrementChildren, decrementChildren} = useInitCase(newProps);


	function handleClick(url) {
		setIframeDoc(url);
		setIsIframe('pdf-viewer-fullscreen fade-in')
	}


	return  confirmNewCase ? <ConfirmNewCase setConfirmNewCase={setConfirmNewCase} />
		:

	(
	isLoading ? <LoadingDocs /> :



	<div>	
		<FormContext.Provider value={value}>
		<BackButton />
		<Spacer />
			<div className='form-div'>
			<h1 className='primary-title'>{lang.studentStayRenewal} {globalForm.id}</h1>


			<Spacer />
			{Object.keys(docPrepop).length > 0 && <p className='p centered-text'>{lang.smartUpload}</p> }

			<div className='upload-grid animated-div'>
			</div>
			

			<Spacer />
				<h3 className='tertiary-title'>{lang.fullPassport}</h3>
				<Spacer25 />
				<div className=''>
				<div className='large-margin'>
				<DragNDrop 
					text={lang.fullPassport} 
					doc='fullPassport' 
					clickCallback={handleClick}
					customStyle='pdf-viewer-small'
					fileNanoID={docPrepopURLs['fullPassport'] ? docPrepopURLs['fullPassport'].uuid : false}
					initialFileURL={docPrepopURLs['fullPassport'] ? docPrepopURLs['fullPassport'].url : false}
					saveFunc={saveCurCase}
				/>
				</div>
				</div>

			<Spacer />
			<h3 className='tertiary-title'>{lang.requiredDocs}</h3>
			<Spacer />	
			{Object.keys(docPrepop).length > 0 && <p className='p centered-text'>{lang.smartUpload}</p> }
			<Spacer25 />
			<div className='two-column-upload-grid animated-div'>

				<DragNDrop 
					text={lang.proofPrevProgramCompletion} 
					doc='proofPrevProgramCompletion'
					clickCallback={handleClick}
					customStyle={'pdf-viewer-small'}
					initialFileURL={docPrepopURLs['proofPrevProgramCompletion'] ? docPrepopURLs['proofPrevProgramCompletion'].url : false}
					fileNanoID={docPrepopURLs['proofPrevProgramCompletion'] ? docPrepopURLs['proofPrevProgramCompletion'].uuid : false}

					saveFunc={saveCurCase}
				/>

				<DragNDrop 
					text={lang.proofProgramContinuation} 
					doc='proofProgramContinuation'
					clickCallback={handleClick}
					customStyle={'pdf-viewer-small'}
					initialFileURL={docPrepopURLs['proofProgramContinuation'] ? docPrepopURLs['proofProgramContinuation'].url : false}
					fileNanoID={docPrepopURLs['proofProgramContinuation'] ? docPrepopURLs['proofProgramContinuation'].uuid : false}

					saveFunc={saveCurCase}
				/>

				<DragNDrop 
					text={lang.financialMeans} 
					doc='financialMeans'
					clickCallback={handleClick}
					customStyle={'pdf-viewer-small'}
					initialFileURL={docPrepopURLs['financialMeans'] ? docPrepopURLs['financialMeans'].url : false}
					fileNanoID={docPrepopURLs['financialMeans'] ? docPrepopURLs['financialMeans'].uuid : false}

					saveFunc={saveCurCase}
				/>

				<DragNDrop 
					text={lang.proofInsurance} 
					doc='proofInsurance'
					clickCallback={handleClick}
					customStyle={'pdf-viewer-small'}
					initialFileURL={docPrepopURLs['proofInsurance'] ? docPrepopURLs['proofInsurance'].url : false}
					fileNanoID={docPrepopURLs['proofInsurance'] ? docPrepopURLs['proofInsurance'].uuid : false}

					saveFunc={saveCurCase}
				/>

			</div>
			
			<Spacer />
			<h3 className='secondary-title centered-text'>{lang.ifNotPresentedBefore}</h3>
			<Spacer />
			<div className='two-column-upload-grid'>
				<DragNDrop 
					text={lang.backgroundCheck} 
					doc='backgroundCheck'
					clickCallback={handleClick}
					customStyle={'pdf-viewer-small'}
					initialFileURL={docPrepopURLs['backgroundCheck'] ? docPrepopURLs['backgroundCheck'].url : false}
					fileNanoID={docPrepopURLs['backgroundCheck'] ? docPrepopURLs['backgroundCheck'].uuid : false}

				/>

				<DragNDrop 
					text={lang.proofHealth} 
					doc='proofHealth'
					clickCallback={handleClick}
					customStyle={'pdf-viewer-small'}
					initialFileURL={docPrepopURLs['proofHealth'] ? docPrepopURLs['proofHealth'].url : false}
					fileNanoID={docPrepopURLs['proofHealth'] ? docPrepopURLs['proofHealth'].uuid : false}

				/>

			</div>

			<Spacer />
			<h3 className='secondary-title centered-text'>{lang.mayBeRequired}</h3>
			<Spacer />
			<div className='large-margin animated-div'>
				<DragNDrop text={lang.poa} 
					doc='poa' 
					clickCallback={handleClick} 
					customStyle='pdf-viewer-small' 
					initialFileURL={docPrepopURLs['poa'] ? docPrepopURLs['poa'].url : false}
					fileNanoID={docPrepopURLs['poa'] ? docPrepopURLs['poa'].uuid : false}

				/>
			</div>
			<Spacer />

			<h3 className='center-flex secondary-title'>{lang.children}</h3>
		{

		}
			<Children 
				smallChildren={smallChildren}
				setSmallChildren={setSmallChildren}
				setNumChildren={setNumChildren}
			/>
		{
			<div className={`${smallChildren ? '' : 'hidden'}`}>
					<Spacer />
					<p className='p larger-font centered-text'>{lang.oneOrBoth}</p>
			{
				Array.from({length: numChildren}).map((_, i) => (
					<div className={`animated-div two-column-upload-grid`}>
						<DragNDrop 
							text={lang.childSchoolEnrollment + ` ${i+1}`} 
							doc={`childSchoolEnrollment${i+1}`}
							fileNanoID={docPrepopURLs[`childSchoolEnrollment${i+1}`] ? docPrepopURLs[`childSchoolEnrollment${i+1}`].uuid : false}
							initialFileURL={docPrepopURLs[`childSchoolEnrollment${i+1}`] ? docPrepopURLs[`childSchoolEnrollment${i+1}`].url : false}
							saveFunc={saveCurCase}
						/>

						<DragNDrop 
							text={lang.childCourseCompletion + ` ${i+1}`} 
							doc={`childCourseCompletion${i+1}`}
							fileNanoID={docPrepopURLs[`childCourseCompletion${i+1}`] ? docPrepopURLs[`childCourseCompletion${i+1}`].uuid : false}
							initialFileURL={docPrepopURLs[`childCourseCompletion${i+1}`] ? docPrepopURLs[`childCourseCompletion${i+1}`].url : false}
							saveFunc={saveCurCase}
						/>
					</div>
				))
			}

			<div className='center-flex'>
				<button className='form-action-btn new-btn' onClick={incrementChildren}>Add child +</button>
				<button className='form-action-btn new-btn' onClick={decrementChildren}>Delete child +</button>
			</div>

			</div>
		}

			<Spacer100 />


			<h3 className='center-flex secondary-title'>{lang.basicInfo}</h3>
			<Spacer />
			<p className='centered-text p'>{lang.smartAutoFill}</p>
			<Spacer25 />
			<BasicInfoForm />
			<Spacer />
			<h3 className='center-flex secondary-title'>{lang.physicalAddress}</h3>
			<Spacer />
			<AddressForm />
			<Spacer />
			<SubmissionArea saveFunc={saveCurCase}/>
		</div>
		</FormContext.Provider>
	</div>
	);
}

export function NonLucrativeResidencyRenewal(props) {
	const newProps = {
		...props,
		caseType: "nonLucrativeResidencyRenewal"
	}

	const {globalForm, setGlobalForm, iframeDoc, setIframeDoc, isIframe, setIsIframe, docPrepop, docPrepopURLs, setDocPrepopURLs, isLoading, setIsLoading, confirmNewCase, setConfirmNewCase, value, smallChildren, setSmallChildren, numChildren, setNumChildren, passportStamp, setPassportStamp, saveCurCase, incrementChildren, decrementChildren} = useInitCase(newProps);

	function handleClick(url) {
		setIframeDoc(url);
		setIsIframe('pdf-viewer-fullscreen fade-in')
	}


	return  confirmNewCase ? <ConfirmNewCase setConfirmNewCase={setConfirmNewCase} />
		:

	(
	isLoading ? <LoadingDocs /> :


	<FormContext.Provider value={value}>
		<BackButton />
		<Spacer />
		<div className='form-div'>
			<h1 className='primary-title'>{lang.nonLucrativeRenewal}</h1>

			<Spacer />
				<h3 className='tertiary-title'>{lang.fullPassport}</h3>
				<Spacer25 />
				<div className=''>
				<div className='large-margin'>
				<DragNDrop 
					text={lang.fullPassport} 
					doc='fullPassport' 
					clickCallback={handleClick}
					customStyle='pdf-viewer-small'
					fileNanoID={docPrepopURLs['fullPassport'] ? docPrepopURLs['fullPassport'].uuid : false}
					initialFileURL={docPrepopURLs['fullPassport'] ? docPrepopURLs['fullPassport'].url : false}
					saveFunc={saveCurCase}
				/>
				</div>
				</div>
		
				<Spacer />
				<h3 className='tertiary-title'>{lang.requiredDocs}</h3>
				<div className='large-margin animated-div'>
				<DragNDrop 
					text={lang.backgroundCheck} 
					doc='backgroundCheck' 
					clickCallback={handleClick}
					customStyle='pdf-viewer-small'
					initialFileURL={docPrepopURLs['backgroundCheck'] ? docPrepopURLs['backgroundCheck'].url : false}
					fileNanoID={docPrepopURLs['backgroundCheck'] ? docPrepopURLs['backgroundCheck'].uuid : false}

					saveFunc={saveCurCase}
				/>
				</div>
				
				<Spacer />
				<h3 className='tertiary-title'>{lang.mayBeRequired}</h3>
				<Spacer />
				<div className='large-margin animated-div'>
				<DragNDrop 
					text={lang.poa} 
					doc='poa' 
					clickCallback={handleClick}
					customStyle='pdf-viewer-small'
					initialFileURL={docPrepopURLs['poa'] ? docPrepopURLs['poa'].url : false}
					fileNanoID={docPrepopURLs['poa'] ? docPrepopURLs['poa'].uuid : false}

					saveFunc={saveCurCase}
				/>
				</div>

			</div>

			<Spacer />
			<h3 className='center-flex secondary-title'>{lang.children}</h3>
		{

		}
			<Children 
				smallChildren={smallChildren}
				setSmallChildren={setSmallChildren}
				setNumChildren={setNumChildren}
			/>
		{
			<div className={`${smallChildren ? '' : 'hidden'}`}>
					<Spacer />
					<p className='p larger-font centered-text'>{lang.oneOrBoth}</p>
			{
				Array.from({length: numChildren}).map((_, i) => (
					<div className={`animated-div two-column-upload-grid`}>
						<DragNDrop 
							text={lang.childSchoolEnrollment + ` ${i+1}`} 
							doc={`childSchoolEnrollment${i+1}`}
							fileNanoID={docPrepopURLs[`childSchoolEnrollment${i+1}`] ? docPrepopURLs[`childSchoolEnrollment${i+1}`].uuid : false}
							initialFileURL={docPrepopURLs[`childSchoolEnrollment${i+1}`] ? docPrepopURLs[`childSchoolEnrollment${i+1}`].url : false}
							saveFunc={saveCurCase}
						/>

						<DragNDrop 
							text={lang.childCourseCompletion + ` ${i+1}`} 
							doc={`childCourseCompletion${i+1}`}
							fileNanoID={docPrepopURLs[`childCourseCompletion${i+1}`] ? docPrepopURLs[`childCourseCompletion${i+1}`].uuid : false}
							initialFileURL={docPrepopURLs[`childCourseCompletion${i+1}`] ? docPrepopURLs[`childCourseCompletion${i+1}`].url : false}
							saveFunc={saveCurCase}
						/>

					</div>
				))
			}

			<div className='center-flex'>
				<button className='form-action-btn new-btn' onClick={incrementChildren}>Add child +</button>
				<button className='form-action-btn new-btn' onClick={decrementChildren}>Delete child +</button>
			</div>

			</div>
		}

			<Spacer100 />

			<h3 className='center-flex secondary-title'>{lang.basicInfo}</h3>
			<Spacer />
			<p className='centered-text p'>{lang.smartAutoFill}</p>
			<Spacer25 />
			<BasicInfoForm />
			<Spacer />
			<h3 className='center-flex secondary-title'>{lang.physicalAddress}</h3>
			<Spacer />
			<AddressForm />
			<Spacer />
			<SubmissionArea saveFunc={saveCurCase}/>
	
		</ FormContext.Provider>
	)
}

export function SpanishCitizenship(props) {
	const newProps = {
		...props,
		caseType: "spanishCitizenship"
	}

	const {globalForm, setGlobalForm, iframeDoc, setIframeDoc, isIframe, setIsIframe, docPrepop, docPrepopURLs, setDocPrepopURLs, isLoading, setIsLoading, confirmNewCase, setConfirmNewCase, value} = useInitCase(newProps);

	function handleClick(url) {
		setIframeDoc(url);
		setIsIframe('pdf-viewer-fullscreen fade-in')
	}

	function saveCurCase(saveForm=null) {
		console.log(`saving`, globalForm)
		if (saveForm)
			setCase(saveForm.id, saveForm);
		else
			setCase(globalForm.id, globalForm);
	}



	return  confirmNewCase ? <ConfirmNewCase setConfirmNewCase={setConfirmNewCase} />
		:

	(
	isLoading ? <LoadingDocs /> :


	<FormContext.Provider value={value}>
	<div>
		<BackButton />
		<Spacer />
		<div className='form-div'>
			<h1 className='primary-title'>{lang.spanishCitizenship}</h1>
			<Spacer />
			<h3 className='center-flex secondary-title'>{lang.basicInfo}</h3>
			<Spacer />
			<p className='centered-text p'>{lang.smartAutoFill}</p>
			<Spacer25 />
			<BasicInfoForm />
			<Spacer />
			<h3 className='center-flex secondary-title'>{lang.physicalAddress}</h3>
			<Spacer />
			<AddressForm />
			<Spacer />
			<SubmissionArea saveFunc={saveCurCase}/>
		</div>
	</div>
	</FormContext.Provider>
	);
}
